import { isNumber, isString } from 'lodash';
import isBrowser from 'utils/isBrowser';

export const scrollTo = (offset, behavior = 'smooth') => {
	if (isBrowser()) {
		globalThis.scroll({
			top: offset,
			behavior,
		});
	}
};

export const scrollToElement = (element, options = {}) => {
	if (!element) {
		return;
	}

	let scrollElement = element;

	if (isString(element)) {
		scrollElement = document.querySelector(element);
	}

	if (!scrollElement) {
		return;
	}

	let offset = scrollElement.offsetTop;
	if (isNumber(options.offset)) {
		offset += options.offset;
	}

	scrollTo(offset, options.behavior);
};

export const setLocation = (path, timeout = 300) => {
	if (isBrowser()) {
		// Wait 300ms for any tracking events to flush
		setTimeout(() => {
			globalThis.location.href = path;
		}, timeout);
	}
};

export function removeUrlParam(paramName) {
	if (isBrowser()) {
		const newUrl = new URL(globalThis.location.href);
		newUrl.searchParams.delete(paramName);
		globalThis.history.replaceState({}, '', newUrl.toString());
	}
}

export const cleanUrl = (url) => url.replaceAll(/\s+/g, '-');

export const toKebabCase = (text) =>
	text.split(' ').splice(0, 4).join('-').toLowerCase();
